import { render, staticRenderFns } from "./ResidentDiffDetailModalForCooperationSystem.vue?vue&type=template&id=94900590&scoped=true&lang=pug"
import script from "./ResidentDiffDetailModalForCooperationSystem.vue?vue&type=script&lang=ts"
export * from "./ResidentDiffDetailModalForCooperationSystem.vue?vue&type=script&lang=ts"
import style0 from "./ResidentDiffDetailModalForCooperationSystem.vue?vue&type=style&index=0&id=94900590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94900590",
  null
  
)

export default component.exports